var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbiscan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#12AAFF",
    d: "M11.48 11.52l-.97 2.66c-.02.07-.02.15 0 .23l1.66 4.57 1.93-1.11-2.31-6.35c-.06-.14-.26-.14-.31 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#12AAFF",
    d: "M13.42 7.06c-.06-.14-.26-.14-.31 0l-.97 2.66c-.02.07-.02.15 0 .23l2.73 7.48 1.93-1.11-3.38-9.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FB9D9",
    d: "M10 1.24c.05 0 .1.02.14.04l7.34 4.24c.09.05.14.14.14.24v8.48c0 .1-.06.19-.14.24l-7.34 4.24c-.04.02-.09.04-.14.04s-.1-.02-.14-.04l-7.34-4.24c-.09-.05-.14-.14-.14-.24V5.76c0-.1.06-.19.14-.24l7.34-4.24c.04-.02.09-.04.14-.04m0-1.24c-.26 0-.52.06-.76.2L1.9 4.44c-.47.27-.76.78-.76 1.31v8.48c0 .54.29 1.04.76 1.31l7.34 4.24c.23.14.5.2.76.2s.52-.06.76-.2l7.34-4.24c.47-.27.76-.78.76-1.31V5.76c0-.54-.29-1.04-.76-1.31L10.76.2C10.52.06 10.26 0 10 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8FB9D9",
    points: "5.14,17.43 5.82,15.58 7.18,16.7 5.9,17.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.38 5.15H7.51c-.14 0-.26.09-.31.22L3.21 16.31l1.93 1.11 4.4-12.05c.04-.11-.04-.22-.16-.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M12.64 5.15h-1.86c-.14 0-.26.09-.31.22l-4.56 12.5 1.93 1.11 4.96-13.61c.04-.11-.04-.22-.16-.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbiscan);
export default __webpack_public_path__ + "static/media/arbiscan.37636f4c0ae92ed65897aaf5b5494ee0.svg";
export { ForwardRef as ReactComponent };